import { Button } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { RenderFeatureFlag } from '~/components/render-feature-flag/RenderFeatureFlag';
import { useFlags } from '~/stores/use-flags/useFlags';

export interface DownloadButtonProps {
  onClick: () => void;
}

export const DownloadButton = ({ onClick }: DownloadButtonProps) => {
  const { t } = useTranslation(['widget']);
  const isUniversalDrawerEnabled = useFlags(state =>
    state.getFeatureFlagState('universal_drawer')
  );

  return (
    <RenderFeatureFlag requiredFlag={'drawer_download'}>
      <Button
        iconName="CloudArrowDown"
        label={
          isUniversalDrawerEnabled
            ? t('widget:downloadInsight')
            : t('widget:download')
        }
        onClick={onClick}
        variant="empty"
        size="xsmall"
      />
    </RenderFeatureFlag>
  );
};
